export default __webpack_public_path__ + "static/fallback-trustpilot-score-66844b0654ca9e1734bfa494b60d3bb1.svg";